import { Divider, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ChargerDtoV2 } from '../dto/charger.dto';
import { useTranslation } from 'react-i18next';
import { getSessionLimit } from '../charger-pricing/utils';

const useStyles = makeStyles(() => ({
  sectionText: {
    color: '#4E5968',
    fontSize: '16px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '24px',
    paddingLeft: '2px',
  },
  listHead: {
    fontFamily: 'Inter',
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 500,
    color: '#202223',
  },
  list: {
    marginTop: '16px',
    marginBottom: '16px',
  },
  gracePeriod: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: '#4E5968',
  },
  discountContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'right',
  },
  active: {
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    color: '#202223',
  },
  discountText: {
    color: '#6B7684',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    textAlign: 'right',
    textDecorationLine: 'line-through',
  },
}));

interface IProps {
  charger: ChargerDtoV2;
}

const SessionLimitComponent = ({ charger }: IProps) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  return (
    <>
      {!!charger.sessionLimit && (
        <Grid container className={classes.list}>
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </Grid>
      )}
      {!!charger.sessionLimit && (
        <Grid container>
          <span
            className={classes.sectionText}
            style={{
              fontWeight: '500',
              width: '100%',
              display: 'flex',
            }}
          >
            <Grid item xs={6}>
              <Typography className={classes.listHead}>{i18n.t('time_limit')}</Typography>
            </Grid>
            <Grid item xs={6} className={classes.discountContainer}>
              <Typography className={classes.active}>
                {`${getSessionLimit(charger.sessionLimit.value, charger.sessionLimit.type)}`}
              </Typography>
            </Grid>
          </span>
          <Grid item xs={12} style={{ paddingLeft: 2 }}>
            <Typography className={classes.gracePeriod}>{i18n.t('time_limit_message')}</Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default SessionLimitComponent;
